import { KeyBy } from "@m7-health/shared-utils";
import { compact, pick, sortBy, uniq, values } from "lodash";

import { IStaffDetails, IStaffType } from "@/api";
import { useStaffCategoryByKey, useStaffTypeByKey } from "@/common/AppConfigUtils";
import { useAppSelector, useDeepMemo } from "@/common/hooks";

const uniqKeys = (
  staffDetails: (IStaffDetails | undefined)[],
  staffTypeByKey: KeyBy<IStaffType, "key">,
) =>
  compact(
    sortBy(
      uniq(
        staffDetails.map((staff) => staff && staffTypeByKey[staff.staffTypeKey]?.staffCategoryKey),
      ),
    ),
  );

export const useAvailableStaffCategories = () => {
  const staffDetails = useAppSelector((state) => state.schedulerGrid.grid.data.staffDetails);
  return useExtractStaffCategories(values(staffDetails));
};

export const useExtractStaffCategories = (staffDetails: (undefined | IStaffDetails)[]) => {
  const staffTypeByKey = useStaffTypeByKey();
  const staffCategoryByKey = useStaffCategoryByKey();

  return useDeepMemo(() => {
    const staffCategoriesKeys = uniqKeys(staffDetails, staffTypeByKey);
    return values(pick(staffCategoryByKey, staffCategoriesKeys));
  }, [staffDetails, staffTypeByKey, staffCategoryByKey]);
};
